import { mapActions, mapState } from 'vuex';

const validationMixin = {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      activeAccount: state => state.auth.activeAccountData,
    }),
  },
  methods: {
    ...mapActions({
      showBoss: 'auth/showBoss',
    }),
    assignBackendErrors(errors) {
      if (errors.length === 0) {
        throw 'Cannot assign backend errors. AssignBackendErrors method parameter is empty';
      }
      for (const error in errors) {
        if (errors.hasOwnProperty(error)) {
          this.errors.add({
            field: error,
            msg: errors[error][0],
          });
        }
      }
    },
    assignBackendErrorsByModel(errors, model, refreshErrors = false) {
      if (errors.length === 0) {
        throw 'Cannot assign backend errors. AssignBackendErrors method parameter is empty';
      }
      if (refreshErrors) {
        this.clearAllErrors();
      }
      for (const key in errors[model]) {
        if (errors[model].hasOwnProperty(key)) {
          const index = this.errors.items.findIndex((error) => error.field == model + '_' + key);
          if (index === -1 || refreshErrors) {
            this.errors.add({
              field: model + '_' + key,
              msg: errors[model][key][0],
            });
          }
        }
      }
    },
    assignBackendErrorsToBagByModel(errors, model, refreshErrors = false, scope) {
      if (scope === undefined) {
        scope = null;
      }

      if (errors.length === 0) {
        throw 'Cannot assign backend errors. AssignBackendErrors method parameter is empty';
      }
      if (refreshErrors) {
        this.errors.clear(scope);
      }

      for (const key in errors[model]) {
        if (!errors[model].hasOwnProperty(key)) {
          continue;
        }
        const fieldName = `${ model }_${ key }`;

        if (this.errors.has(fieldName, scope)) {
          continue;
        }
        this.errors.add({
          field: fieldName,
          msg: errors[model][key][0],
          scope,
        });
      }
    },

    addError(field, msg) {
      this.errors.add({
        field: field,
        msg: msg,
      });
    },
    hubValidate(scope = null) {
      return this.$validator.validateAll(scope);
    },
    clearAllErrors() {
      this.errors.clear();
    },
    clearErrorsOnChange(field, scope) {
      if (scope === undefined) {
        scope = null;
      }
      this.errors.remove(field, scope);
    },
    getPersonData() {
      return new Promise((resolve, reject) => {
        let person;
        if (parseInt(this.activeAccount.crmId)) {
          //if user switched to different account get that person data
          person = this.activeAccount.personData;
          resolve(person);
        } else {
          this.showBoss().then((response) => {
            person = response.data;
            resolve(person);
          });
        }
      });
    },
    validateProfileData() {
      return this.getPersonData().then((person) => {
        let errors = [];

        if (!person.company || !person.company.nip) {
          errors.push('NIP');
        }

        if (!person.company || !person.company.name) {
          errors.push('nazwa firmy');
        }

        if (!person.personbankaccount || !person.personbankaccount.main_bank_account) {
          errors.push('główne konto bankowe');
        }

        if (errors.length === 0) {
          return true;
        }

        let storagePerson = JSON.parse(localStorage.getItem('person'));
        if (!parseInt(this.activeAccount.crmId) && parseInt(storagePerson.id) !== parseInt(person.id)) {
          this.$vs.dialog({
            color: 'warning',
            title: `Brak danych do wystawienia faktur`,
            text: `Brakuje danych właściciela firmy. Niezbędne pola do uzupełnienia: ` + errors.join(', '),
            acceptText: 'Ok',
          });

          return false;
        }

        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: `Brak danych`,
          text: `Aby wygenerować faktury, należy uzupełnić w profilu następujące pola: ` + errors.join(', '),
          acceptText: 'Edytuj',
          cancelText: 'Wróć',
          accept: () => {
            if (parseInt(this.activeAccount.crmId)) {
              this.$router.push('/clients/edit/' + this.activeAccount.crmId).catch(() => {
              });
            } else {
              this.$router.push('/profile/edit/').catch(() => {
              });
            }
          },
        });

        return false;
      });
    },
    isResponseStatus(response, status) {
      if (!'status' in response) {
        return false;
      }

      if (!response?.data) {
        return false;
      }

      return response.status === status;
    },
  },
};
export default validationMixin;
